import {useSelector} from 'react-redux'
import {getPricePredictionParam} from 'components/PriceTrend/services/preload'
import {useGetPricePredictionQuery} from 'components/PriceTrend/services/priceInsightsApi'
import {getIsNoDatesSearch} from 'modules/search/selectors'

/**
 * Predicted nightly prices for the price prediction calendar on the dateless AP,
 * with the request parameters they were fetched for. SSR preloads the same
 * query, so all consumers share one request and cache entry. `prices` is
 * undefined while loading and when the feature does not apply.
 */
export const usePricePrediction = (hotelId: string | undefined) => {
  const isNoDatesSearch = useSelector(getIsNoDatesSearch)
  const shouldRequestPricePrediction = Boolean(hotelId) && isNoDatesSearch

  const params = useSelector(state =>
    getPricePredictionParam(state, hotelId ?? '')
  )
  const {prices} = useGetPricePredictionQuery(params, {
    selectFromResult: result => ({prices: result?.data?.prices}),
    skip: !shouldRequestPricePrediction
  })

  const hasPrices = prices && prices.length
  // The API can return a full calendar with every price at zero, which has
  // nothing to show.
  const hasAvailablePrices = hasPrices && prices.some(({price}) => price > 0)

  return {
    prices,
    nights: params.nights,
    occupancy: Number(params.roomConfiguration),
    hasAvailablePrices
  }
}
